export const CLOSE_MOBILE_SIGN_MODAL_ACTION = 'MOBILE_SIGN.CLOSE_MOBILE_SIGN_MODAL_ACTION';
export const START_MOBILE_SIGNING_ACTION = 'MOBILE_SIGN.START_MOBILE_SIGNING_ACTION';
